<!-- Loading -->
<ng-container *ngIf="(assignmentSubject | async) == null">
    <div class="text-center">
        <span><i class="fa-solid fa-spinner fa-spin"></i></span>
    </div>
</ng-container>

<!-- Finished Loading -->
<ng-container *ngIf="(assignmentSubject | async) != null">
    <div class="alert alert-secondary" *ngIf="!(assignmentSubject | async)!.length">
        {{'assignments.emptyList' | transloco}}
    </div>

    <div class="d-flex flex-column gap-2 text-center" *ngIf="(assignmentSubject | async)!.length">
        <div *ngFor="let assignment of assignmentSubject | async" (click)="onAssignmentClick(assignment)"
            [attr.role]="getItemRole(assignment)">
            <div class="text-decoration-none text-dark w-100 shadow-sm p-3 bg-white d-block rounded"
                [ngClass]="{'border border-warning': assignment.isSearchingSubstitute!}">
                <div class="d-flex align-items-center gap-3 w-100">
                    <div class="flex-grow-1 overflow-hidden text-start">
                        <div class="mb-2 lh-1" *ngIf="assignment.isSearchingSubstitute!">
                            <div class="d-flex flex-row">
                                <i class="fa-solid fa-triangle-exclamation me-2 text-warning"></i>
                                <span class="h8 text-warning">{{'assignments.openToTakeover' | transloco}}</span>
                            </div>
                        </div>
                        <div class="d-flex align-items-center">
                            <i class="fa-regular fa-calendar-days me-1"></i>
                            <span class="fs-4 mb-0 fw-regular text-start text-nowrap">
                                {{ assignment.from | date: "EE dd.MM.yy | HH:mm" }}
                            </span>
                            <span class="fs-4"> - </span>
                            <span class="fs-4 mb-0 fw-regular text-start text-nowrap">
                                <ng-container
                                    *ngIf="isAssignmentOnSameDay(assignment.from, assignment.to) else fullDate">
                                    {{ assignment.to | date: "HH:mm" }}
                                </ng-container>
                                <ng-template #fullDate>
                                    {{ assignment.to | date: "EE dd.MM.yy | HH:mm" }}
                                </ng-template>
                            </span>
                        </div>
                        <div class="fs-4 mb-0 fw-bold text-truncate">
                            <span class="h8">{{assignment.sportName}} | {{assignment.title}}</span>
                            <ng-container *ngIf="assignment.level">
                                <span class="h8">, {{assignment.level}}</span>
                            </ng-container>
                        </div>
                        <p class="fs-4 fw-regular" *ngIf="assignment.location != null">
                            {{ assignment.location }}
                        </p>
                        <ng-container *ngIf="displayFinanceInformation">
                            <p class="fs-4 fw-regular">
                                <b>{{'assignments.provSalary' | transloco}}: </b>
                                <span *ngIf="assignment.provSalaryStatus == null">
                                    {{'shared.swissFranc' |transloco}} {{ assignment.provSalary | number: '1.2-2'}}
                                </span>
                                <span *ngIf="assignment.provSalaryStatus != null">{{assignment.provSalaryStatus}}</span>
                                <span *ngIf="assignment.reasonForAbsence != null"> |
                                    {{assignment.reasonForAbsence}}</span>
                                <span *ngIf="assignment.isShortTimeWork"> | Kurzarbeit</span>
                            </p>
                            <p class="fs-4 fw-regular" *ngIf="assignment.salaryDetails">
                                <b>{{'assignments.billedAssignments.salaryDetails' | transloco}}: </b>
                                <span>
                                    {{ assignment.salaryDetails}}
                                </span>
                            </p>
                        </ng-container>
                    </div>
                    <div>
                        <ng-container *ngIf="eventType === assignmentEventType.RouteToDetails && assignment.hasDetails">
                            <i class="fa fa-chevron-right text-primary"></i>
                        </ng-container>
                        <ng-container *ngIf="eventType === assignmentEventType.Checkbox">
                            <input type="checkbox" [checked]="isAssignmentSelected(assignment.uniqueRandomId)"
                                (click)="$event.stopPropagation(); toggleAssignmentSelection(assignment)" />
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>